function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#666766;}\n");

var _ref3 =
/*#__PURE__*/
React.createElement("rect", {
  x: 0,
  y: 0,
  transform: "matrix(-1 -4.486867e-11 4.486867e-11 -1 36 110)",
  className: "st0",
  width: 36,
  height: 110
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  className: "st1",
  d: "M13.393,64.5c0.115,0,0.223-0.044,0.304-0.124l9.214-9.077c0.081-0.08,0.126-0.187,0.126-0.299 c0-0.113-0.045-0.219-0.126-0.299l-9.214-9.077c-0.081-0.08-0.189-0.124-0.304-0.124c-0.115,0-0.223,0.044-0.304,0.124 c-0.167,0.165-0.167,0.433,0,0.598L22,55l-8.911,8.778c-0.167,0.165-0.167,0.433,0,0.598C13.17,64.456,13.278,64.5,13.393,64.5z"
});

var SvgCarrouselArrowRight1 = function SvgCarrouselArrowRight1(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 110",
    style: {
      enableBackground: "new 0 0 36 110"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCarrouselArrowRight1, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/carrousel-arrow-right-1.68c57fea.svg";
export { ForwardRef as ReactComponent };